'use client';

import { c as _c } from "react/compiler-runtime";
import React, { FC, PropsWithChildren } from 'react';
import { useProductsContext } from '@ordering/providers/ProductsProvider/ProductsProvider';
import { groupProductsBySections } from '@ordering/api/utils/groupProductsBySections';
import { MenuSectionsProvider } from '@ordering/providers/SectionsProvider/SectionsProvider';
import { useSchedule } from '@ordering/providers/ScheduleProvider/ScheduleProvider';
import { useStorefrontConfig } from '@ordering/providers/StorefrontConfig/StorefrontConfig';
import { useGetFulfilAt, useHasHydrated } from '@ordering/stores/OrderStore/hooks';
import Loading from '@ordering/app/loading';
import { getScheduleEntryForDateTime } from '@ordering/providers/ScheduleProvider/getCurrentSchedule';
import { usePromotions } from '@ordering/providers/PromotionsProvider/PromotionsProvider';
const Layout: FC<PropsWithChildren> = props => {
  const $ = _c(16);
  const {
    children
  } = props;
  const {
    products
  } = useProductsContext();
  const {
    currentOrNextSchedule,
    timezone
  } = useSchedule();
  const {
    schedule
  } = useStorefrontConfig();
  const {
    activeOffers
  } = usePromotions();
  const fulfilAt = useGetFulfilAt();
  const hasHydrated = useHasHydrated();
  let t0;
  bb0: {
    if (!fulfilAt) {
      t0 = currentOrNextSchedule;
      break bb0;
    }
    let t1;
    if ($[0] !== currentOrNextSchedule || $[1] !== fulfilAt || $[2] !== schedule || $[3] !== timezone) {
      t1 = getScheduleEntryForDateTime(schedule, timezone, fulfilAt) ?? currentOrNextSchedule;
      $[0] = currentOrNextSchedule;
      $[1] = fulfilAt;
      $[2] = schedule;
      $[3] = timezone;
      $[4] = t1;
    } else {
      t1 = $[4];
    }
    t0 = t1;
  }
  const activeSchedule = t0;
  if (!hasHydrated) {
    let t1;
    if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = <Loading />;
      $[5] = t1;
    } else {
      t1 = $[5];
    }
    return t1;
  }
  const menu = activeSchedule.menus?.[0];
  if (!menu) {
    let t1;
    if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = <p>No menus configured.</p>;
      $[6] = t1;
    } else {
      t1 = $[6];
    }
    return t1;
  }
  let t1;
  if ($[7] !== activeOffers) {
    t1 = activeOffers ?? [];
    $[7] = activeOffers;
    $[8] = t1;
  } else {
    t1 = $[8];
  }
  let t2;
  if ($[9] !== menu.sections || $[10] !== products || $[11] !== t1) {
    t2 = groupProductsBySections(products, menu.sections, t1);
    $[9] = menu.sections;
    $[10] = products;
    $[11] = t1;
    $[12] = t2;
  } else {
    t2 = $[12];
  }
  const sections = t2;
  let t3;
  if ($[13] !== children || $[14] !== sections) {
    t3 = <MenuSectionsProvider sections={sections}>{children}</MenuSectionsProvider>;
    $[13] = children;
    $[14] = sections;
    $[15] = t3;
  } else {
    t3 = $[15];
  }
  return t3;
};
export default Layout;